import { render, staticRenderFns } from "./TermsNew.vue?vue&type=template&id=60f750a5&"
import script from "./TermsNew.vue?vue&type=script&lang=js&"
export * from "./TermsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports